import Button from "../../../shared/components/Button";
import InfoTooltip from "../../../shared/components/InfoTooltip";
import { siteTexts } from "../../../shared/i18n/siteTexts";
import type {
  ChallengeCategoryCode,
  ChallengeCategoryGender,
  ChallengeType,
} from "../../challenges/types/challengeAdmin";
import {
  categoryGenderLabel,
  categoryLabel,
  challengeTypeLabel,
} from "../../challenges/utils/challengeLabels";

type AdminCreateChallengeCategoryFieldsProps = {
  category: ChallengeCategoryCode;
  categoryFemale: ChallengeCategoryCode;
  categoryGender: ChallengeCategoryGender;
  categoryMale: ChallengeCategoryCode;
  categoryOptions: ChallengeCategoryCode[];
  challengeType: ChallengeType;
  challengeTypes: ChallengeType[];
  genderOptions: ChallengeCategoryGender[];
  setCategory: (value: ChallengeCategoryCode) => void;
  setCategoryFemale: (value: ChallengeCategoryCode) => void;
  setCategoryGender: (value: ChallengeCategoryGender) => void;
  setCategoryMale: (value: ChallengeCategoryCode) => void;
  setChallengeType: (value: ChallengeType) => void;
};

export default function AdminCreateChallengeCategoryFields({
  category,
  categoryFemale,
  categoryGender,
  categoryMale,
  categoryOptions,
  challengeType,
  challengeTypes,
  genderOptions,
  setCategory,
  setCategoryFemale,
  setCategoryGender,
  setCategoryMale,
  setChallengeType,
}: AdminCreateChallengeCategoryFieldsProps) {
  const createTexts = siteTexts.admin.createChallengePage;
  const info = siteTexts.common.info;

  return (
    <>
      <div className="status-filter-buttons">
        {challengeTypes.map((type) => (
          <Button
            key={type}
            type="button"
            variant="pill"
            className={challengeType === type ? "active" : ""}
            onClick={() => setChallengeType(type)}
          >
            {challengeTypeLabel(type)}
          </Button>
        ))}
      </div>

      {challengeType === "super8" && (
        <div className="admin-row-two">
          <label className="field">
            <span className="info-label">
              {createTexts.gender}
              <InfoTooltip content={info.openCategory} />
            </span>
            <select
              value={categoryGender}
              onChange={(event) =>
                setCategoryGender(event.target.value as ChallengeCategoryGender)
              }
            >
              {genderOptions.map((item) => (
                <option key={`create-gender-${item}`} value={item}>
                  {categoryGenderLabel(item)}
                </option>
              ))}
            </select>
          </label>

          {categoryGender === "mixed" || categoryGender === "open" ? (
            <>
              <label className="field">
                <span className="info-label">
                  {createTexts.maleCategory}
                  <InfoTooltip content={info.category} />
                </span>
                <select
                  value={categoryMale}
                  onChange={(event) =>
                    setCategoryMale(event.target.value as ChallengeCategoryCode)
                  }
                >
                  {categoryOptions.map((item) => (
                    <option key={`create-category-m-${item}`} value={item}>
                      {categoryLabel(item)}
                    </option>
                  ))}
                </select>
              </label>
              <label className="field">
                <span className="info-label">
                  {createTexts.femaleCategory}
                  <InfoTooltip content={info.category} />
                </span>
                <select
                  value={categoryFemale}
                  onChange={(event) =>
                    setCategoryFemale(event.target.value as ChallengeCategoryCode)
                  }
                >
                  {categoryOptions.map((item) => (
                    <option key={`create-category-f-${item}`} value={item}>
                      {categoryLabel(item)}
                    </option>
                  ))}
                </select>
              </label>
            </>
          ) : (
            <label className="field">
              <span className="info-label">
                {createTexts.category}
                <InfoTooltip content={info.category} />
              </span>
              <select
                value={category}
                onChange={(event) =>
                  setCategory(event.target.value as ChallengeCategoryCode)
                }
              >
                {categoryOptions.map((item) => (
                  <option key={`create-category-${item}`} value={item}>
                    {categoryLabel(item)}
                  </option>
                ))}
              </select>
            </label>
          )}
        </div>
      )}
    </>
  );
}
